import { IXmlNode } from '@/app-modules/server-communications';
import { DefaultStageElement } from '@/components/game/implementations/_default/_domain/models';
import { WinnersData } from '@/components/game/_domain';

class DefaultWinners extends WinnersData {
    protected getStages(node: IXmlNode): DefaultStageElement[] {
      return [{ name: 'prize', stage: 1 }];
    }

    protected getJackpotStage(): number {
        return 0;
    }

    constructor(node: IXmlNode) {
        super(node);
    }
}

export { DefaultWinners };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_domain/models/winners.ts